import type { FaireProductEntity } from "../../entity_types/product";

export const p_cxq62r6kfp: FaireProductEntity = {
  token: "p_cxq62r6kfp",
  type: "product",
  name: "Mini Mystery Dumplings- 24ct",
  brandToken: "b_c4q5qhejkf",
  brandName: "K & S WHOLESALE INC",
  imageUrl:
    "https://cdn.faire.com/fastly/46cdc8db70a41ef75694160efc75c218305fbdd9b6020777bcd2a4808e90216b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/40a1a0e189395178a8594647b38b2e3a36934dee3e9b505ebad9766a03683563.jpeg",
    "https://cdn.faire.com/fastly/b6a65514ec3533011615e30af4eccdf89955c0d299eaf12c49b05463a23ca8bc.jpeg",
    "https://cdn.faire.com/fastly/c1619bf6572cfdfe5c385a1c58f4e7c71bd7e3e85e6b3bfc7b8f114954e0c5aa.jpeg",
    "https://cdn.faire.com/fastly/c2da3b3de6ea15d2bd3d215bed64bc38b9004c2eea5a549899b5b8f4e7d54b7f.jpeg",
    "https://cdn.faire.com/fastly/0f7d1b5d6ea4a9a684625175b2df6c5cccc135fcda8da6374feb26713550aaf1.jpeg",
    "https://cdn.faire.com/fastly/65467b2b31a22f78f3512eb291062800f3dff88109e5bb9213a992cfba9ec1f2.jpeg",
  ],
  priceDollars: 4,
  description:
    "Add a fun and eye-catching sensory item to your novelty and impulse toy selection with the Mini Bun Squishy. Designed in a cute steamed bun style with colorful printed wrap packaging, this soft squishy toy delivers a satisfying squeeze and slow-rising feel that kids love. Perfect for checkout counters, toy aisles, party favor sections, and fidget displays, this playful item is a great grab-and-go choice for everyday sales.\n\nFeatures:\n– Item does not come in clear plastic wrap to reduce waste\n– Cute steamed bun / dumpling-inspired squishy toy\n– Soft, slow-rising sensory squeeze texture\n– Great for fidget fun, stress relief, and impulse sales\n– Ideal for toy shops, gift stores, party supply, and novelty displays",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:45.014Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
